import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import messages from './messages'

import RelatedDocumentBody from 'modules/RelatedDocuments/RelatedDocumentsBody'
import AppTools from 'utils/app/appTools'

class ContentDraggable extends Component {
  constructor(props) {
    super(props)
    const {
      intl: { formatMessage }
    } = props
    this.formatMessage = formatMessage
    this.state = {
      collapsed: true
    }
    this.draggableRef = React.createRef()
  }

  componentDidMount() {
    this.props.getRef(this.draggableRef)
  }

  renderIfAllOK() {
    let renderingComponent = null
    const layer = this.props.layer
    const level = this.props.level
    let levelTitle
    let levelNumber
    if (layer === 1) {
      levelTitle = AppTools.getTitleFromLevel(level)
      levelNumber = levelTitle.levelNumber.toLowerCase()
      levelNumber = levelNumber.slice(0, -1)
    }

    renderingComponent = (
      <div ref={this.draggableRef} className={`ork-related-documents ${this.props.open ? '' : 'invisible'}`}>
        <div className="ork-related-documents__heading">
          <span className="ork-related-documents__heading__drag">
            <i className="fal fa-expand-arrows" />
          </span>
          <span className="ork-related-documents__title">
            <i className="fal fa-file-alt fa-lg" />{' '}
            <span className="ork-u-ml">
              {this.formatMessage(messages.relatedDocuments)} {levelNumber ? `(${levelNumber})` : ''}
            </span>
          </span>
          <span className="ork-related-documents__heading__close" onClick={this.props.close}>
            <i className="fal fa-times fa-lg" />
          </span>
        </div>
        <RelatedDocumentBody
          layer={this.props.layer}
          level={this.props.level}
          indicator={this.props.indicator}
          areAvailable={this.props.areAvailable}
        />
      </div>
    )

    return renderingComponent
  }

  render() {
    return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
  }
}
export default injectIntl(ContentDraggable)



// WEBPACK FOOTER //
// ./src/modules/RelatedDocuments/RelatedDocumentsDraggable/RelatedDocumentsDraggable.jsx